module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/2_73c12045fb6c1cbfc2032b8086f2646c.png";